'use client';

import React from 'react';
import Link from 'next/link';

export type PolicySection = {
  title: string;
  paragraphs?: string[];
  bullets?: string[];
};

interface PolicyPageProps {
  eyebrow: string;
  title: string;
  updatedAt: string;
  intro: string;
  sections: PolicySection[];
}

export default function PolicyPage({ eyebrow, title, updatedAt, intro, sections }: PolicyPageProps) {
  return (
    <main className="min-h-screen bg-background">
      <section className="py-20 lg:py-28">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 border border-primary/20 text-primary text-xs font-semibold mb-5">
            {eyebrow}
          </div>
          <h1 className="text-3xl sm:text-4xl font-bold text-foreground mb-4">{title}</h1>
          <p className="text-sm text-muted-foreground mb-2">Last updated: {updatedAt}</p>
          <p className="text-lg text-muted-foreground max-w-3xl">{intro}</p>

          <div className="mt-10 space-y-6">
            {sections.map((section) => (
              <section key={section.title} className="card-elevated p-6">
                <h2 className="text-lg font-semibold text-foreground mb-3">{section.title}</h2>
                <div className="space-y-3 text-sm leading-7 text-muted-foreground">
                  {section.paragraphs?.map((paragraph) => (
                    <p key={paragraph.slice(0, 40)}>{paragraph}</p>
                  ))}
                  {section.bullets && (
                    <ul className="list-disc pl-5 space-y-2">
                      {section.bullets.map((bullet) => (
                        <li key={bullet}>{bullet}</li>
                      ))}
                    </ul>
                  )}
                </div>
              </section>
            ))}
          </div>

          <div className="mt-8 flex flex-wrap items-center gap-3">
            <Link href="/" className="btn-secondary py-2 text-sm">
              Back to Home
            </Link>
            <Link href="/pricing" className="btn-primary py-2 text-sm">
              View Pricing
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}
